import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "label"]
  static values = { 
    url: String,
    field: String
  }

  connect() {
    console.log('[Toggle] Connected')
  }

  toggle(event) {
    const checked = this.checkboxTarget.checked
    const csrfToken = document.querySelector('meta[name="csrf-token"]').content

    fetch(this.urlValue, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrfToken,
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        site_setting: {
          [this.fieldValue]: checked
        }
      })
    })
    .then(response => response.json())
    .then(data => {
      if (data.success) {
        this.updateLabel(checked)
      } else {
        // Revert on error
        this.checkboxTarget.checked = !checked
        console.error('[Toggle] Update failed:', data.error)
      }
    })
    .catch(error => {
      // Revert on error
      this.checkboxTarget.checked = !checked
      console.error('[Toggle] Error:', error)
    })
  }

  updateLabel(enabled) {
    if (this.hasLabelTarget) {
      this.labelTarget.textContent = enabled ? 'Enabled' : 'Disabled'
      this.labelTarget.classList.toggle('text-emerald-600', enabled)
      this.labelTarget.classList.toggle('text-gray-500', !enabled)
    }
  }
}
